export const HomePage = '/m'

export const BindBotPage = '/m/bindbot'

export const MyKnowledgePage = '/m/knowledge'

export const KnowledgeDetailPage = '/index/knowledge-detail'

export const MyBotPage = '/m/mybot'

export const BotDetailPage = '/m/bot-detail'

export const SetNewsBotPage = '/m/set-news-bot'

export const NewsBotDetailPage = '/m/news-bot-detail'

export const BotKnowledgesPage = '/m/bot-knowledges'

export const ScheduleRemindPage = '/m/schedule-remind'

export const ScheduleRemindDetailPage = '/m/schedule-remind-detail'

export const BotStorePage = '/m/botstore'

export const LearningPage = '/m/learning'

export const QuestionDetailPage = '/m/question-detail'

export const CombileKnowledgePage = '/m/combine-knowledge'

export const ProductIntroPage = '/m/help'
export const ManageGroupPage = '/m/manage-group'

export const BindWechatPage = '/m/bind-bot'
export const WechatBotPage = '/m/wechat-bot'
export const ContactsPage = '/m/contacts'

export const HelpPage = '/m/help'

export const SigninPage = '/auth/signin'

export const SignupPage = '/auth/signup'

export const Reset = '/auth/reset'

export const GroupDataStatisticsPage = '/m/group-data-statistics'

export const BotPushServicePage = '/m/bot-push-service'
export const BotPushServiceDetailPage = '/m/bot-push-service-detail'

export const PasswordPage = '/m/password'

export const NoticePage = '/m/notice'

export const GroupWelcomePage = '/m/group-welcome'
